import { BILL_PROCESSING_FILTER_ACTION, BILL_PROCESSING_FILTER_ACTION_SUCCESS, BILL_PROCESSING_REPORT_ACTION, BILL_PROCESSING_REPORT_ACTION_SUCCESS, BILL_PROCESSING_REPORT_ERROR_ACTION } from "./actionType";



export const BillProcessingReport_Action = (config = {}) => ({
    type: BILL_PROCESSING_REPORT_ACTION,
    config,
});


export const BillProcessingReport_Action_Success = (resp) => ({
    type: BILL_PROCESSING_REPORT_ACTION_SUCCESS,
    payload: resp,

})



export const BillProcessingFilter_Action = (config = {}) => ({
    type: BILL_PROCESSING_FILTER_ACTION,
    config,
});


export const BillProcessingFilter_Action_Success = (resp) => ({
    type: BILL_PROCESSING_FILTER_ACTION_SUCCESS,
    payload: resp,

})

export const BillProcessingReport_ErrorAction = (resp) => ({
    type: BILL_PROCESSING_REPORT_ERROR_ACTION,
    payload: resp,

})